import store from '../reducers/storeRegistration';
const getUser = () => {
  const user = store.getState().login.user;
  return user || {};
};

/**
 * this returns general permissions for user.
 */
export const evaluate = async /* entity, entityName, source */ () => {
  const user = getUser();
  return user.permissions.general;
};
export default {
  evaluate
};